<template>
    <div class="sms-campaigns">

        <!-- Título da página -->
        <mu-title color="secondary" textStrong="700">Relatórios</mu-title>

        <!-- Breadcrumbs -->
        <mu-breadcrumbs divider="—">
            <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
            <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
        </mu-breadcrumbs>

        <!-- Lista das opções de menu -->
        <mu-options :options="options"></mu-options>

    </div>
</template>

<script>
    export default {
        name: 'app-reports-dashboard',
        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Serviços',
                        route: 'app.services',
                        disabled: false
                    },
                    {
                        text: 'Relatórios',
                        disabled: true
                    }
                ],
                options: [
                    {
                        key: 1,
                        icon: '/svg/menu/reports-date.svg',
                        route: 'app.services.reports.analytical.index',
                        title: 'Relatório Analítico',
                        description: 'Relatório detalhado com as informações ref. a envio e respostas por período.',
                        permition: ['S', 'A', 'C', 'U']
                    },
                    {
                        key: 2,
                        icon: '/svg/menu/reports-synthetic.svg',
                        route: 'app.services.reports.synthetic.index',
                        title: 'Relatório Sintético',
                        description: 'Relatório sintético de seus clientes com total dos envios e respostas por mês.',
                        permition: ['S', 'A', 'C', 'U'],
                        permition_company: ['R']
                    }
                    // ,
                    // {
                    //     key: 3,
                    //     icon: '/svg/menu/reports-campaign.svg',
                    //     route: 'app.services.reports.general.index',
                    //     title: 'Relatório Simples',
                    //     description: 'Relatório simples com as informações ref. a envio e respostas.',
                    //     permition: ['S', 'A', 'C', 'U']
                    // }
                ]
            }
        }
    }
</script>
